// src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  Button,
  Input,
  Typography,
  Card,
  CardContent,
  Stack,
  Box,
  Link,
} from '@mui/joy';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setError('');
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_HOST}/loginNOENTE`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });

      if (!res.ok) throw new Error('Errore dal server');

      const data = await res.json();
      if (data.user?.error === 'INVALID_PASSWORD') throw new Error('Credenziali errate');
      const user = data.user;
      const userId = user.id;
      const isSuperadmin = user?.is_superadmin === true || user?.is_superadmin === "true";

      localStorage.setItem('isSuperadmin', JSON.stringify(isSuperadmin));
      localStorage.setItem('user', JSON.stringify(data));
      localStorage.setItem('username', JSON.stringify(user));
      localStorage.setItem('userId', JSON.stringify(userId));

      const meRes = await fetch(`${process.env.REACT_APP_SERVER_HOST}/me`, {
        credentials: 'include',
      });

      if (!meRes.ok) throw new Error('Token non valido o non ancora salvato');

      navigate('/dashboard');
      window.location.reload();

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      {/* Disclaimer in alto */}
      <Typography
        level="body-sm"
        color="warning"
        textAlign="center"
        sx={{ mt: 2, maxWidth: 600, mx: 'auto' }}
      >
        L'accesso alla piattaforma è consentito esclusivamente agli utenti autorizzati.
      </Typography>

      <Card sx={{ maxWidth: 400, mx: 'auto', mt: 4, p: 3 }}>
        <CardContent>
          <Stack spacing={3}>
            {/* Logo e scritta */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
              <img
                src={`${process.env.REACT_APP_SERVER_HOST}/assets/img/logo/SEM.svg`}
                alt="Logo SEM"
                style={{ width: 40, height: 40 }}
              />
              <Typography component="h1" level="h5">
                SEM - Admin
              </Typography>
            </Box>

            {/* Titolo e sottotitolo */}
            <Box>
              <Typography level="h4">Benvenuto su SEM 🚑</Typography>
              <Typography level="body-sm" color="neutral">
                Effettua il login
              </Typography>
            </Box>

            {/* Form */}
            <Input
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="danger" level="body-sm">
                {error}
              </Typography>
            )}
            <Button onClick={handleLogin}>Accedi</Button>

            {/* Link cambia password */}
            <Box sx={{ textAlign: 'center' }}>
              <Link component={RouterLink} to="/change-password" level="body-sm">
                Cambia password
              </Link>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
